var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format } from 'date-fns';
import { AptiveIcon } from '@aptive-env/storybook';
import { convert24HourTo12Hour } from 'utils/convertHour';
import { getCalendarEventTypeColors } from 'utils/color';
import { BknDay, BknNight, BlizzardDay, BlizzardNight, FewDay, FewNight, FogDay, FogNight, FzraDay, FzraNight, OvcDay, OvcNight, RainDay, RainNight, RainShowersDay, RainShowersNight, RainSnowDay, RainSnowNight, SctDay, SctNight, SkcDay, SkcNight, SleetDay, SleetNight, SnowDay, SnowNight, TropicalStormDay, TropicalStormNight, TsraDay, TsraNight, TsraSctDay, TsraSctNight, WindDay, WindNight } from 'icons';
var CalendarDayList = function (_a) {
    var data = _a.data;
    var renderWeatherIcon = function (icon) {
        var renderContent = _jsx(_Fragment, {});
        switch (icon) {
            case 'bkn_day':
                renderContent = _jsx(BknDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'bkn_night':
                renderContent = _jsx(BknNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'blizzard_day':
                renderContent = _jsx(BlizzardDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'blizzard_night':
                renderContent = _jsx(BlizzardNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'few_day':
                renderContent = _jsx(FewDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'few_night':
                renderContent = _jsx(FewNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'fog_day':
                renderContent = _jsx(FogDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'fog_night':
                renderContent = _jsx(FogNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'fzra_day':
                renderContent = _jsx(FzraDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'fzra_night':
                renderContent = _jsx(FzraNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'ovc_day':
                renderContent = _jsx(OvcDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'ovc_night':
                renderContent = _jsx(OvcNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'rain_day':
                renderContent = _jsx(RainDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'rain_night':
                renderContent = _jsx(RainNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'rain_showers_day':
                renderContent = _jsx(RainShowersDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'rain_showers_night':
                renderContent = _jsx(RainShowersNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'rain_snow_day':
                renderContent = _jsx(RainSnowDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'rain_snow_night':
                renderContent = _jsx(RainSnowNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'sct_day':
                renderContent = _jsx(SctDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'sct_night':
                renderContent = _jsx(SctNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'skc_day':
                renderContent = _jsx(SkcDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'skc_night':
                renderContent = _jsx(SkcNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'sleet_day':
                renderContent = _jsx(SleetDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'sleet_night':
                renderContent = _jsx(SleetNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'snow_day':
                renderContent = _jsx(SnowDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'snow_night':
                renderContent = _jsx(SnowNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'tropical_storm_day':
                renderContent = _jsx(TropicalStormDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'tropical_storm_night':
                renderContent = _jsx(TropicalStormNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'tsra_day':
                renderContent = _jsx(TsraDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'tsra_night':
                renderContent = _jsx(TsraNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'tsra_sct_day':
                renderContent = _jsx(TsraSctDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'tsra_sct_night':
                renderContent = _jsx(TsraSctNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'wind_day':
                renderContent = _jsx(WindDay, { className: "w-[20px] h-[20px] rounded" });
                break;
            case 'wind_night':
                renderContent = _jsx(WindNight, { className: "w-[20px] h-[20px] rounded" });
                break;
            default:
                break;
        }
        return renderContent;
    };
    return (_jsx("div", __assign({ className: "overflow-auto flex-auto" }, { children: data.map(function (item, index) { return (_jsxs("div", __assign({ className: "flex flex-col p-4 gap-2.5" }, { children: [_jsxs("div", __assign({ className: "flex items-center justify-between bg-[#F9FAFB] rounded-lg h-[44px] px-2" }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-1" }, { children: [_jsx("div", __assign({ className: "text-xSmallBold font-inter uppercase ".concat(index === 0 ? 'text-text-default' : 'text-[#A9A9A9]') }, { children: item.name })), _jsx("div", __assign({ className: "text-xs font-normal leading-4 font-inter ".concat(index === 0 ? 'text-text-default' : 'text-[#A9A9A9]') }, { children: format(item.date, 'MMMM d') }))] })), item.weather && (_jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsxs("span", __assign({ className: "font-inter text-[#A9A9A9] text-sm font-semibold leading-4" }, { children: [item.weather.temperature.day, "\u00BA"] })), _jsxs("span", __assign({ className: "font-inter text-[#A9A9A9] text-sm font-semibold leading-4 mr-1" }, { children: ["/ ", item.weather.temperature.night, "\u00BA"] })), renderWeatherIcon(item.weather.icon)] })))] })), _jsx(_Fragment, { children: item.events.length === 0 ? (_jsx("div", __assign({ className: "text-sm\tfont-normal leading-4 text-text-default text-center" }, { children: "No Events" }))) : (item.events.map(function (event) { return (_jsxs("div", __assign({ className: "px-4 flex flex-col cursor-pointer ".concat(event.is_canceled === 'true' ? 'hidden' : '') }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-1.5" }, { children: [_jsx(AptiveIcon, { className: 'w-[12px] h-[12px] stroke-none', icon: "clock", style: { fill: getCalendarEventTypeColors(event.event_type).dark }, isFilled: true }), _jsx("div", __assign({ className: "text-sm leading-normal text-text-default" }, { children: "".concat(convert24HourTo12Hour(event.start_at), " - ").concat(convert24HourTo12Hour(event.end_at)) }))] })), _jsx("div", __assign({ className: "text-sm font-semibold leading-4 text-text-default" }, { children: event.title }))] }), event.id)); })) })] }), index)); }) })));
};
export default CalendarDayList;
